<script>
  import Datepicker from "vuejs-datepicker"
  import { ptBR } from "vuejs-datepicker/dist/locale"
  import { dateFormat } from "@/core/services/helpers"
  export default {
    components: {
      Datepicker,
    },
    props: {
      name: {
        type: String,
        required: true,
      },
      value: {
        type: [String, Date],
        default: "",
      },
      id: {
        type: String,
        default: null,
      },
      label: {
        type: String,
        default: null,
      },
      options: {
        type: Array,
        default: () => [],
      },
      inputClasses: {
        type: String,
        default: "",
      },
      placeholder: {
        type: String,
        default: "",
      },
      type: {
        type: String,
        default: "text",
      },
      icon: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        dateFormat,
        locale: ptBR,
        localValue: this.value,
      }
    },
    watch: {
      value(newValue) {
        this.localValue = newValue
      },
    },
    methods: {
      handleChange(event) {
        if (this.type === "date") {
          this.$emit("input", event)
          return
        }
        this.$emit("input", event.target.value)
      },
    },
  }
</script>
<style>
  .filter-form-input {
    appearance: none;
    background-color: #ffffff;
    border-color: #d2d6dc;
    border-width: 1px;
    border-radius: 0.375rem;
    padding-top: 0px !important;
    padding-right: 0px !important;
    padding-bottom: 0px !important;
    font-size: 1rem;
    line-height: 1.5;
    height: 2.5em;
  }

  .filter-form-input::placeholder {
    color: #9fa6b2;
    opacity: 1;
  }

  .filter-form-input:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
    border-color: #a4cafe;
  }

  .filter-form-icon {
    position: relative;
    top: -1.3rem;
    left: 0.7rem;
  }
</style>

<template>
  <div>
    <template v-if="type == 'text'">
      <input
        :id="id"
        v-model="localValue"
        :name="name"
        :placeholder="placeholder"
        :type="type"
        :class="[
                    inputClasses,
                    'filter-form-input form-input mb-0',
                    { 'pl-7': icon },
                ]"
        @change="handleChange"
      >
    </template>
    <template v-else-if="type == 'date'">
      <Datepicker
        v-model="localValue"
        :placeholder="placeholder"
        :format="dateFormat"
        :language="locale"
        :full-month-name="true"
        :input-class="[
                    'filter-form-input form-input mb-0',
                    { 'pl-7': icon },
                ]"
        @selected="handleChange"
      />
    </template>
    <template v-if="icon">
      <img
        class="filter-form-icon h-3 mr-2 z-50"
        :src="require(`@/core/assets/images/${icon}`)"
      >
    </template>
  </div>
</template>
